<template>
  <div
    class='theme-input__field-holder'
    :class="{
      'theme-input__field-holder--error': !!errors.has(newName),
      'theme-input__field-holder--focused': isFocused,
    }"
    data-vv-value-path='model'
    :data-vv-as='label || validationLabel'
    :data-vv-validate-on='validateOn'
  >
    <label class='theme-input__label' v-if='labelHtml' v-html='labelHtml'></label>
    <label class='theme-input__label' v-else-if='label'>
      {{ label }}
      <span v-if='isRequired' class='theme-input__label-asterisk'>*</span>
    </label>
    <div class='theme-input__wrapper'>
      <input
        :class="['theme-input', {
          'theme-input--green': green,
          'theme-input--blue': blue,
          'theme-input--extra': isExtraInfo,
        }]"
        :value='model'
        @input='onInput'
        @keydown.space="trim ? $event.preventDefault() : null"
        :type='type || `text`'
        :inputmode='inputmode'
        :data-vv-validate-on='validateOn'
        :name='name'
        :disabled='disabled'
        :placeholder='placeholder'
        :min='min'
        :max='max'
        :readonly='isReadonly'
        @change="$emit('change', $event)"
        @blur="
          $emit('blur', $event);
          isFocused = false;
        "
        @focus="
          $emit('focus', $event);
          isFocused = true;
        "
      />
      <span
        v-if='errors.has(newName)'
        class='icon-warning theme-input__icon theme-input__icon-error'
        :class="{'theme-input__icon-error-password': type === 'password'}">
      </span>
      <i
        v-if="type == 'password'"
        class='fa fa-eye-slash'
        style='right: 14px; cursor: pointer; position: absolute; top: 18px'
        @click='togglePassword'
        :title='locales && locales.common && locales.common.show_password'
      />
      <div class='theme-input__extra-info' v-if='isExtraInfo'>
        <slot name='extra-info'></slot>
      </div>
    </div>
    <div class='theme-input__extra-note' v-if='isExtraNote'>
      <slot name='extra-note'></slot>
    </div>
    <div class='theme-input__error-text' v-if='errors.has(newName)'>
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../admin/mixins/field';
  import {mapGetters} from 'vuex';
  import {isReadonly} from 'vue';
  import {filterDecimalInput, filterIntegerInput} from '../helpers/decimalFilter';

  export default {
    data() {
      return {
        isFocused: false,
      };
    },
    computed: {
      ...mapGetters(['locales']),
    },
    mounted() {},
    mixins: [field],
    props: {
      placeholder: {
        default: '',
        type: String,
      },
      min: {
        default: '',
        type: [String, Number],
      },
      max: {
        default: '',
        type: String,
      },
      inputmode: {
        default: null,
        type: String,
      },
      // Validation-only friendly name (vee-validate data-vv-as) used when the
      // field has no visible label prop. Never rendered as a visible label.
      validationLabel: {
        default: '',
        type: String,
      },
      // vee-validate v2 trigger override (e.g. "blur") so decimal price fields do
      // not flag transient in-progress values on every keystroke. Null keeps the
      // existing aggressive default for all other callers.
      validateOn: {
        default: null,
        type: String,
      },
      // Opt-in live input sanitizer. "decimal" strips non-decimal characters
      // while typing/pasting (see helpers/decimalFilter). Null = no filtering,
      // so all existing callers are unchanged.
      inputFilter: {
        default: null,
        type: String,
      },
      labelHtml: {
        default() {
          return '';
        },
        type: String,
      },
      isExtraInfo: {
        default: false,
        type: Boolean,
      },
      isExtraNote: {
        default: false,
        type: Boolean,
      },
      isRequired: {
        default: false,
        type: Boolean,
      },
      green: {
        default: false,
        type: Boolean,
      },
      blue: {
        default: false,
        type: Boolean,
      },
      isReadonly: {
        default: false,
        type: Boolean,
      },
      trim: {
        default: false,
        type: Boolean,
      },
    },
    methods: {
      onInput(event) {
        var value = event && event.target ? event.target.value : '';
        if (this.trim) {
          var normalized = value.replace(/\s+/g, '');
          if (normalized !== value && event && event.target) {
            event.target.value = normalized;
          }
          value = normalized;
        }
        if (this.inputFilter === 'decimal' || this.inputFilter === 'integer') {
          var filtered = this.inputFilter === 'integer'
            ? filterIntegerInput(value)
            : filterDecimalInput(value);
          if (filtered !== value && event && event.target) {
            event.target.value = filtered;
          }
          value = filtered;
        }
        this.model = value;
      },
      togglePassword(e) {
        var togglePassword = $(e.target);
        var password = togglePassword.parent().find('[name=\'' + this.name + '\']').first();
        var type = password.attr('type') === 'password' ? 'text' : 'password';
        password.attr('type', type);
        togglePassword.toggleClass('fa-eye');
        togglePassword.toggleClass('fa-eye-slash');
      },
    },
  };
</script>
